/* eslint-disable import/prefer-default-export */
import {
  postWithAuth
} from './http.service';

import { OPENAI_QUESTIONS } from './url.service';

export const getOpenAIQuestions = (data) => postWithAuth(OPENAI_QUESTIONS(), data);
